// extracted by mini-css-extract-plugin
export default {"boxContainer":"SettingCard_boxContainer__39pNY","headerTitle":"SettingCard_headerTitle__hmXoO"};